<template>
    <v-dialog v-model="dialogSwitch" persistent scrollable width="600">
        <v-card>
            <v-card-title id="heading" class="d-flex justify-space-between">
                <h4>Add User to a "{{ company.company_name }}" Company</h4>
                <v-btn density="compact" icon="mdi-close" variant="flat" @click="$emit('update:modelValue',false)"/>
            </v-card-title>

            <v-container>
                <v-form v-model="formData.valid" class="mb-3" validate-on="input lazy" @submit.prevent="addUser">
                    <v-alert v-if="errors.length"
                             class="mb-3 bg-error"
                             closable close-label="Close Alert"
                             density="compact" variant="tonal">
                        <p v-for="error in errors">{{ error }}</p>
                    </v-alert>
                    <v-row>
                        <v-col cols="12" sm="6">
                            <v-select v-model="formData['role']"
                                      :items="filteredRoles"
                                      :rules="[vRules.required]"
                                      density="compact"
                                      item-value="id"
                                      label="Role" return-object @update:model-value="fetchUsers"/>
                        </v-col>

                        <v-col cols="12" sm="6">
                            <v-autocomplete v-model="formData['user']" :items="users" :rules="[vRules.required]"
                                            density="compact"
                                            item-title="email"
                                            item-value="id"
                                            label="User"
                                            return-object>
                                <template v-slot:item="{ props, item }">
                                    <v-list-item
                                        :subtitle="`${item.raw.first_name} ${item.raw.last_name}`"
                                        v-bind="props"></v-list-item>
                                </template>
                            </v-autocomplete>
                        </v-col>

                        <v-col class="py-0 text-right" cols="12">
                            <v-btn :disabled="!formData.valid" color="primary" size="small" type="submit">Save</v-btn>
                        </v-col>
                    </v-row>

                </v-form>
            </v-container>
        </v-card>
    </v-dialog>
</template>


<script setup>
import {computed, onMounted, reactive, ref} from "vue";
import {useSnackbarStore} from "@/stores/snackBarStore";
import {send} from "@/composables/apiClient";

const emits = defineEmits(['update:modelValue', 'updateUsers']);
const snackbar = useSnackbarStore();
const props = defineProps({
    modelValue: Boolean,
    company: Object,
    roles: Array
});
const dialogSwitch = ref(props.modelValue);
const formData = reactive({
    valid: false,
    user: null,
    role: null,
});
const errors = ref([]);
const users = ref([]);

const filteredRoles = computed(() => {
    return props.roles.filter((role) => role.role_type === 'api' || role.portal_id === props.company.portal_id);
})

const fetchUsers = () => {
    if (formData['role']) {
        send('get', `users`, {exclude_company: props.company.id, type: formData['role']['role_type'], list: 1})
            .then((response) => {
                users.value = response.data.data;
            })
            .catch((error) => {
                console.log(error)
                showSnackbar('Users could not be loaded', 'error')
            });
    }
}
const addUser = () => {
    errors.value = [];
    send('put', `users/${formData.user.id}/company`, {company: props.company.id, role: formData.role.id})
        .then((response) => {
            snackbar.showSnackbar(response.data.message);
            if (response.data.success) {
                emits('updateUsers', {...formData.user, role_id: formData.role.id, role: formData.role.title});
                emits('update:modelValue', false);
            }
        })
        .catch(function (errorResponse) {
            if (errorResponse.response.data.errors) {
                let validationErrors = errorResponse.response.data.errors;
                Object.keys(validationErrors).forEach((key) => {
                    errors.value.push(validationErrors[key][0]);
                });
            } else if (errorResponse.response.data.message) {
                errors.value.push(errorResponse.response.data.message);
            }
            snackbar.showSnackbar('Something went wrong', 'error');
            document.getElementById('heading').scrollIntoView({behavior: 'smooth'});
        })
}
</script>
